import { Route, Routes } from 'react-router-dom';
import { Layout } from './Layout/Layout';
import { LayoutAuth } from './Layout/LayoutAuth';

import { HomeNavigation } from '../pages/home/HomeNavigation';
import { ForgotPasswordPage } from '../pages/forgotPassword/components/ForgotPasswordPage';
import { VerifyEmailForgotPasswordPage } from '../pages/forgotPassword/components/VerifyEmailForgotPasswordPage';
import { NewPasswordPage } from '../pages/forgotPassword/components/NewPasswordPage';
import { SignUpPage } from '../pages/sign-up';
import { VerifyEmailPage } from '../pages/verify-email';
import { SignInPage } from '../pages/SignIn/components/SignInPage';
import { EmailVerified } from '../modules/SignIn/components/EmailVerified/EmailVerified';
import { ContactPage } from '../pages/contact';
import About from '../modules/About/About';
import Terms from '../modules/TermsAndConditions/TermsAndConditions';
import Privacy from '../modules/PrivacyPolicy/PrivacyPolicy';
import GlassDemoPage from '../pages/glassDemo/GlassDemoPage';
import { Dashboard } from '../modules/dashbord';
import Income from '../modules/Income/Income';
import { Expenses } from '../modules/Expenses/Expenses';
import Transactions from '../modules/Transactions/Transactions';
import Goals from '../modules/Goals/Goals';
import Profile from '../modules/Profile/Profile';
import { AIAdvisorPage } from '../pages/ai-advisor';
import { StatementImports } from '../modules/StatementImports/StatementImports';
import ComingSoon from '../modules/ComingSoon/ComingSoon';
import CalendarView from '../modules/Calendar/Calendar';
import { NotFound } from '../modules/not-found';

export const AppRouts = () => {
	return (
		<Routes>
			<Route
				path='/'
				element={
					<Layout>
						<HomeNavigation />
					</Layout>
				}
			/>
			<Route
				path='/sign-up'
				element={
					<Layout>
						<SignUpPage />
					</Layout>
				}
			/>
			<Route
				path='/verify-email'
				element={
					<Layout>
						<VerifyEmailPage />
					</Layout>
				}
			/>
			<Route
				path='/sign-in'
				element={
					<Layout>
						<SignInPage />
					</Layout>
				}
			/>
			<Route
				path='/email-verified'
				element={
					<Layout>
						<EmailVerified />
					</Layout>
				}
			/>
			<Route
				path='/forgot-password'
				element={
					<Layout>
						<ForgotPasswordPage />
					</Layout>
				}
			/>
			<Route
				path='/overview'
				element={
					<LayoutAuth>
						<Dashboard />
					</LayoutAuth>
				}
			/>
			<Route
				path='/income'
				element={
					<LayoutAuth>
						<Income />
					</LayoutAuth>
				}
			/>
			<Route
				path='*'
				element={
					<Layout>
						<NotFound />
					</Layout>
				}
			/>
			<Route
				path='/expenses'
				element={
					<LayoutAuth>
						<Expenses />
					</LayoutAuth>
				}
			/>
			<Route
				path='/transactions'
				element={
					<LayoutAuth>
						<Transactions />
					</LayoutAuth>
				}
			/>
			<Route
				path='/goals'
				element={
					<LayoutAuth>
						<Goals />
					</LayoutAuth>
				}
			/>
			<Route
				path='/ai-advisor'
				element={
					<LayoutAuth>
						<AIAdvisorPage />
					</LayoutAuth>
				}
			/>
			<Route
				path='/statement-imports'
				element={
					<LayoutAuth>
						<StatementImports />
					</LayoutAuth>
				}
			/>
			<Route
				path='/profile'
				element={
					<LayoutAuth>
						<Profile />
					</LayoutAuth>
				}
			/>
			<Route
				path='/education-hub'
				element={
					<LayoutAuth>
						<ComingSoon titleId='NavBarAuthId11' />
					</LayoutAuth>
				}
			/>
			<Route
				path='/calendar-view'
				element={
					<LayoutAuth>
						<CalendarView />
					</LayoutAuth>
				}
			/>
			<Route
				path='/settings'
				element={
					<LayoutAuth>
						<ComingSoon titleId='SettingsIDTitle' />
					</LayoutAuth>
				}
			/>
			<Route
				path='/verification-forgot-password'
				element={
					<Layout>
						<VerifyEmailForgotPasswordPage />
					</Layout>
				}
			/>
			<Route
				path='/new-forgot-password'
				element={
					<Layout>
						<NewPasswordPage />
					</Layout>
				}
			/>
			<Route
				path='/reset-password'
				element={
					<Layout>
						<NewPasswordPage />
					</Layout>
				}
			/>
			<Route
				path='/about'
				element={
					<Layout>
						<About />
					</Layout>
				}
			/>
			<Route
				path='/contact'
				element={
					<Layout>
						<ContactPage />
					</Layout>
				}
			/>
			<Route
				path='/terms'
				element={
					<Layout>
						<Terms />
					</Layout>
				}
			/>
			<Route
				path='/privacy'
				element={
					<Layout>
						<Privacy />
					</Layout>
				}
			/>
			<Route
				path='/demo/glass'
				element={
					<Layout>
						<GlassDemoPage />
					</Layout>
				}
			/>
		</Routes>
	);
};
